<template>
  <aside v-show="isAsideVisible" class="aside is-placed-left is-expanded">
    <aside-tools :is-main-menu="true">
      <span slot="label" class="comp-logo">
      <img v-if="company.logo === null" src="../assets/icon-logo.png" alt="logo" class="logo">
      <img v-else :src="company.logo" alt="logo" class="logo">
      <p> {{ company.company_name }}</p></span>
    </aside-tools>
    <div class="menu is-menu-main">
      <div class="main" v-if="sortedFacility.isolated.length > 0">
        <div class="img-head"><p class="cap">
          <b-icon
            icon="database"
            size="is-medium"></b-icon>Isolated </p></div>
        <div class="sub-main">
          <ul v-for="(item, index) in sortedFacility.isolated" :key="index">
            <span  class="address" :class="{ active: index === activeIndex }" @click="$emit('index-change', index)"><li> # {{ item.address }}</li></span>
          </ul>
        </div>
      </div>
      <div class="main" v-if="sortedFacility.station.length > 0">
        <div class="img-head"><p class="cap">
          <b-icon
            icon="gas-station"
            size="is-medium"></b-icon>Filling Station </p></div>
        <div class="sub-main">
          <ul v-for="(item, index) in sortedFacility.station" :key="index">
            <span  class="address" :class="{ active: index === activeIndex }" @click="$emit('index-change', index)"><li> # {{ item.address }}</li></span>
          </ul>
        </div>
      </div>
      <div class="main" v-if="sortedFacility.tanker.length > 0">
        <div class="img-head"><p class="cap">
          <b-icon
            icon="tanker-truck"
            size="is-medium"></b-icon>Tanker </p></div>
        <div class="sub-main">
          <ul v-for="(item, index) in sortedFacility.tanker" :key="index">
            <span class="address" :class="{ active: index === activeIndex }" @click="$emit('index-change', index)"><li> # {{ item.address }}</li></span>
          </ul>
        </div>
      </div>
    </div>
    <!-- <div class="menu is-menu-main" v-if="facility.length === 1">
      <div class="main" v-for="(item, index) in facility" :key="index">
        <div class="img-head" v-if="item.facility_type == 'station'"><p class="cap active">
          <b-icon
            icon="gas-station"
            size="is-medium"></b-icon>{{ item.facility_type }} </p></div>
        <div class="img-head" v-else-if="item.facility_type == 'isolated'">
          <p class="cap active">
            <b-icon
            icon="database"
            size="is-medium">
          </b-icon> {{ item.facility_type }} </p></div>
        <div class="img-head" v-else-if="item.facility_type == 'tanker'">
          <p class="cap active">
            <b-icon
            icon="tanker-truck"
            size="is-medium"></b-icon> {{ item.facility_type }} </p></div>
        <div class="sub-main">
          <ul>
            <span class="address active"><li> # {{ item.address }}</li></span>
          </ul>
        </div>
      </div>
    </div>
    <div class="menu is-menu-main" v-else>
      <div class="main" v-for="(storage, index) in type" :key="index">
        <div class="img-head" v-if="storage === 'station'"><img src="../assets/nossle.png" alt="logo"><p class="cap"> {{ storage }} </p></div>
        <div class="img-head" v-if="storage === 'isolated'"><img src="../assets/water tank.png" alt="logo"><p class="cap"> {{ storage }} </p></div>
        <div class="img-head" v-if="storage === 'tanker'"><img src="../assets/tanker.png" alt="logo"><p class="cap"> {{ storage }} </p></div>
        <div class="sub-main" v-for="(item, index) in facility" :key="index">
          <ul v-if="item.facility_type === storage">
            <span class="address" @click="$emit('index-change', index); setIndex(index)" :class="{ active: activeIndex === index }"><p> # {{ item.facility_name }}</p></span>
          </ul>
        </div>
      </div>
    </div> -->
  </aside>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import AsideTools from '@/components/AsideTools.vue';

export default {
  name: 'AsideMenu',
  data: () => ({
    type: null,
    activeIndex: 0,
    sidebarData: null
  }),
  components: { AsideTools },
  props: {
    menu: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState(['isAsideVisible']),
    ...mapGetters(['getLoggedUser']),
    ...mapGetters('apps', {
      company: 'getCompanyDetails',
      facility: 'getFacilityDetails',
      sortedFacility: 'getSortedFacility'
    })
  },
  async mounted() {
    await this.fetchCompanyDetails(this.getLoggedUser.company_id);
    await this.fetchFacilityDetails(this.getLoggedUser.company_id);
    await this.getFacility(this.facility);
    this.sidebarData = this.facility;
  },
  methods: {
    ...mapActions('apps', [
      'fetchCompanyDetails',
      'fetchFacilityDetails'
    ]),
    setIndex(i) {
      this.activeIndex = i;
    },
    getFacility(arr) {
      const types = [];
      arr.forEach(element => {
        if (!types.includes(element.facility_type)) {
          types.push(element.facility_type);
        }
      });
      this.type = types;
      return this.type;
    }
  }
};
</script>

<style scoped>
p.cap {
  text-transform: capitalize;
}
.comp-logo{
  display: flex;
  align-items: center;
}
.comp-logo p {
  margin-left: 15px;
}
.logo {
  height: 20px;
}
.main{
  margin-left: 20px;
}
.main:has(.active) p.cap {
  color: #5051db !important;
}
.img-head{
  display: flex;
  justify-items: center;
  margin-top: 30px;
  align-content: center;
}
.img-head img{
  width: 10px;
  height: 20px;
}
.img-head p{
  margin-left: 10px;
}
.active {
  color: #5051db !important;
}
.sub-main{
  margin-left: 30px;
}
.sub-main ul{
  margin-top: 10px;
}
.address {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  color: #817F7F;
  cursor: pointer;
}
@media screen {
  aside.aside {
    margin-left: 0
  }
}
</style>
